import { onUnmounted } from 'vue';
import { isPublicAuthPath } from '@/utils/public-auth-path';
import { useHFetch } from './http/use-http-request';
import { refreshAppSettings } from './use-update-settings';

/** Interval for polling `settingsUrl/_timestamp` to detect config changes. */
export const SETTINGS_AUTO_REFRESH_INTERVAL_MS = 60_000;

/**
 * Periodically checks `settingsUrl/_timestamp` and refetches settings only when changed.
 * Initial load on page reload is handled by useHUpdateSettings in the settings plugin.
 */
export function useSettingsAutoRefresh(intervalMs = SETTINGS_AUTO_REFRESH_INTERVAL_MS, settingsUrl = 'my/config/settings') {
  if (isPublicAuthPath()) {
    return;
  }

  const httpClient = useHFetch();

  const intervalId = setInterval(() => {
    refreshAppSettings(settingsUrl, httpClient).catch((error) => {
      console.warn('[settings] Settings auto-refresh failed; will retry on next interval:', error);
    });
  }, intervalMs);

  onUnmounted(() => {
    clearInterval(intervalId);
  });
}
